<p-dialog [(visible)]="showModal" [style]="{width: '100vw',padding:'0 15px',border:'none',maxHeight:'100%'}" [modal]="true" [showHeader]="false" [closable]="false"
  appendTo="body">
  <div style="padding: 0px;" *ngIf="model != null">
    <div class="invoice-order-body">
      <div class="activeinvoice-header">
        <div class="invoice-detail">
          <div *ngIf="showHeader" class="medium large-text">Invoice {{model?.number}}</div>
          <span *ngIf="(model.carrierPaid == 4 && carrierPaymentStatus == '') || carrierPaymentStatus == 4"
            class="payment-on-hold">
            Payment On Hold
          </span>
        </div>
        <div *ngIf="showHeader && model?.orderId > 0" class="invoice-btn">
          <button pButton [label]="'Download Invoice'" class="custom-button-compact btn-green" type="button"
            (click)="downloadInvoice()" style="margin-left: 7px"></button>
          <button pButton [label]="'Show Order'" class="custom-button-compact btn-skyblue" type="button" (click)="showOrder()"
            style="margin-left: 9px"></button>
          <div class="link-button invoice-close-btn">
            <a class="muted7" (click)="close()"><img src="./assets/images/close.svg" alt="close" class="filter-invert" /></a>
          </div>
        </div>
      </div>
      <div *ngIf="showHeader" class="small-text invoice-small-text">
        {{model?.statusName}}
        <div style="font-size: 1.5em; margin-left: 5px;">
          <order-tags [order]="model.order"></order-tags>
        </div>
      </div>
      <div *ngIf="showHeader" style="border-bottom: 1px solid #B4B4B4; padding-top:10px;"></div>
      <div class="invoice-detail-table table-view">
        <table class="detail-table">
          <th id="invoice-details-header" class="th-display-none"></th>
          <tbody>
            <tr>
              <td>Status, Flag:</td>
              <td> {{(!isAdding) ? model?.order?.statusName : ''}}</td>
              <td class="bold table-style">{{metadata['assignedToName2']}}</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model?.order?.createdByName"></dynamic-value>
              </td>
              <td class="bold">Confirmed Ready (for Pickup) By:</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model?.order?.confirmedBy"></dynamic-value>
              </td>
              <td class="bold table-style">{{metadata['dispatchedByName']}}</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model?.order?.dispatchedByName"></dynamic-value>
              </td>
            </tr>
            <tr *ngIf="model.status <= 3">
              <td>Assigned Rep:</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model?.order?.assignedToName"></dynamic-value>
              </td>
              <td class="bold table-style">Created On:</td>
              <td>
                <dynamic-value [type]="'datetime'" [value]="model?.order?.createdOn"></dynamic-value>
              </td>
              <td class="bold"> Confirmed Ready (for Pickup) On:</td>
              <td>
                <dynamic-value [type]="'datetime'" [value]="model?.order?.confirmedByDateTime"></dynamic-value>
              </td>
              <td class="bold table-style">Dispatched On:</td>
              <td>
                <dynamic-value [type]="'datetime'" [value]="model?.order?.dispatchedOn"></dynamic-value>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="invoice-order">
      <div>
        <invoice-form [model]="model" (saveComplete)="markClean()" (markDirty)="dirty = true" (revertClose)="cancel()"></invoice-form>
      </div>
      <div class="row">
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Customer Info</div>
            <div class="border-bottom"></div>
            <div class="cards-items">
              <table class="detail-table">
                <th id="invoice-details-customer-info" class="th-display-none"></th>
                <tbody>
                  <tr>
                    <td>{{model.formMetadata['customerBusinessName']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.customerBusinessName"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>Business Hours:</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.order.customerBusinessHours"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>Address:</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.customerAddress1" display="block"></dynamic-value>
                      <dynamic-value [type]="'text'"
                        [value]="model?.order?.customerCity"></dynamic-value>{{(model?.order?.customerCity
                      &&
                      (model?.customerStateCode || model?.customerZip)) ? ', ' : ''}}<dynamic-value [type]="'text'"
                        [value]="model?.order?.customerStateCode"></dynamic-value>&nbsp;<dynamic-value [type]="'zip'"
                        [value]="model?.order?.customerZip"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>Phone:</td>
                    <td>
                      <dynamic-value [type]="'phone'" [value]="model.order.customerPhone"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>Contact & Phone:</td>
                    <td>
                      <contacts-detail [model]="model.customerContacts"></contacts-detail>
                    </td>
                  </tr>
                  <tr>
                    <td>Contact Email:</td>
                    <td>
                      <dynamic-value *ngIf="!anyCustomerContacts" type="text"></dynamic-value>
                      <div *ngFor="let d of model.customerContacts">
                        <dynamic-value [type]="'email'" [value]="d.email"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td> Who needs Customer Docs:</td>
                    <td>
                      <div *ngIf="!isNewCustomerDocOrder">
                        <dynamic-value [type]="'lookup'" [value]="model?.order?.customerDocs" [items]="lookups.yesNoNull">
                        </dynamic-value>
                      </div>
                      <div *ngIf="isNewCustomerDocOrder">
                        <dynamic-value [type]="'lookupMultiSelect'" [value]="model?.order?.customerDocs"
                          [items]="lookups.customerDocs">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr> -->
                  <tr *ngIf="isNewCustomerDocOrder && model?.order?.customerDocCustomer">
                    <td [style.background]="model?.order?.customerDocCustomer != null && model?.order?.customerDocCustomer?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">Customer Needs:</td>
                    <td [style.background]="model?.order?.customerDocCustomer != null && model?.order?.customerDocCustomer?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">
                      <dynamic-value [type]="'lookupMultiSelect'" [value]="model?.order?.customerDocCustomer"
                        [items]="lookups.customerDocOptions"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="isNewCustomerDocOrder && model?.order?.customerDocPickup">
                    <td [style.background]="model?.order?.customerDocPickup != null && model?.order?.customerDocPickup?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">Pickup Needs:</td>
                    <td [style.background]="model?.order?.customerDocPickup != null && model?.order?.customerDocPickup?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">
                      <dynamic-value [type]="'lookupMultiSelect'" [value]="model?.order?.customerDocPickup"
                        [items]="lookups.customerDocOptions"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="isNewCustomerDocOrder && model?.order?.customerDocDelivery">
                    <td [style.background]="model?.order?.customerDocDelivery != null && model?.order?.customerDocDelivery?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">Delivery Needs:</td>
                    <td [style.background]="model?.order?.customerDocDelivery != null && model?.order?.customerDocDelivery?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">
                      <dynamic-value [type]="'lookupMultiSelect'" [value]="model?.order?.customerDocDelivery"
                        [items]="lookups.customerDocOptions"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>Date all Customer Docs Signed:</td>
                    <td>
                      <dynamic-value [type]="'date'" [value]="model?.order?.customerDocsSignedDate"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['segment']}}</td>
                    <td>
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model?.order?.segment" [items]="lookups.segment"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['subsegment']}}</td>
                    <td>
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model?.order?.subSegment"
                          [items]="model?.order?.segment === 6 ? lookups.subsegmentupfitter: lookups.sources"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="isShowPickupPassword && !isTenderOrder">
                    <td>{{detailMetadata['pickupPassword']}}</td>
                    <td>
                      <div class="table-data pickup-password">
                        <dynamic-value [type]="'text'" [value]="model?.order?.pickupPassword"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Pickup Info</div>
            <div class="border-bottom"></div>
            <div class="delivery-cards-items">
              <table class="detail-table">
                <th id="order-detail-pickup-info" class="th-display-none"></th>
                <tbody>
                  @if (isNewRecordForDateOverhual) {
                    <div class="date-overhaul-record">
                      @for (customerExpectedPickupDate of customerExpectedPickupDates; track customerExpectedPickupDate; let i = $index) {
                        <tr>
                          <td>{{detailMetadata['customerExpectedPickupDates']}} {{i+1}}</td>
                          <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: customerExpectedPickupDate }"></ng-template>
                        </tr>
                      }
                    </div>
                  }
                  <tr>
                    <td>{{detailMetadata['customerExpectedPickup']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.customerExpectedPickup"></dynamic-value>
                    </td>
                  </tr>
                  @if (isNewRecordForDateOverhual) {
                    <div class="date-overhaul-record">
                      @for (carrierScheduledPickupDate of carrierScheduledPickupDates; track carrierScheduledPickupDate; let i = $index) {
                        <tr>
                          <td>{{detailMetadata['carrierScheduledPickupDates']}} {{i+1}}</td>
                          <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: carrierScheduledPickupDate }"></ng-template>
                        </tr>
                      }
                    </div>
                  }
                  <tr>
                    <td>{{isNewRecordForDateOverhual ?  detailMetadata['carrierPickupDateNote'] : detailMetadata['scheduledPickup']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.scheduledPickup"></dynamic-value>
                    </td>
                  </tr>
                  @if (isNewRecordForDateOverhual) {
                    <div class="date-overhaul-record">
                      @for (pickupNewETADate of pickupNewETADates; track pickupNewETADate; let i = $index) {
                        <tr>
                          <td>{{detailMetadata['pickupNewETADates']}} {{i+1}}</td>
                          <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: pickupNewETADate }"></ng-template>
                        </tr>
                      }
                    </div>
                  }
                  <tr>
                    <td>{{detailMetadata['actualPickupDate']}}
                      <div class="table-data">
                        <dynamic-value [type]="'date'" [value]="model?.order?.actualPickupDate"></dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">{{detailMetadata['pickupConfirmedBy']}}
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model?.order?.pickupConfirmedBy"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['pickupUpdatedUser']}}
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model?.order?.pickupUpdatedUser"></dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">{{detailMetadata['pickupUpdatedTimedate']}}
                      <div class="table-data">
                        <dynamic-value [type]="'datetime'" [value]="model?.order?.pickupUpdatedTimedate"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="model?.order?.callback1">
                    <td>{{detailMetadata['callback1date']}}:
                      <div class="table-data">
                       <span class="font-weight-normal"> {{ model?.order?.callback1date |  date: 'MM/dd/yyyy' }} </span>
                      </div>
                    </td>
                    <td class="order-detail-font">{{detailMetadata['callback1time_only']}}:
                      <div class="table-data">
                        <span class="font-weight-normal"> {{model?.order?.callback1date | date:'mediumTime'}}</span>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="model?.order?.callback1">
                    <td>{{detailMetadata['callback1note']}}</td>
                    <td>
                      <dynamic-value [type]="'textarea'" [class]="'callback-readonly-height callback-inputbox'" [value]="model?.order?.callback1note"></dynamic-value>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="border-bottom-delivery"></div>
            <div class="cards-items">
              <table class="detail-table">
                <tbody>
                  <tr>
                    <td>{{detailMetadata['pickupBusinessName']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.pickupBusinessName"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['pickupBusinessHours']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.pickupBusinessHours"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['pickupAddress1']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.pickupAddress1" display="block"></dynamic-value>
                      <dynamic-value [type]="'text'" [value]="model?.order?.pickupCity"></dynamic-value>{{(model?.order?.pickupCity &&
                      (model?.order?.pickupStateCode || model?.order?.pickupZip)) ? ', ' : ''}} <dynamic-value [type]="'text'"
                        [value]="model.order?.pickupStateCode"></dynamic-value>&nbsp;<dynamic-value [type]="'zip'"
                        [value]="model.order?.pickupZip"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['pickupPhone']}}</td>
                    <td>
                        <dynamic-value [type]="'phone'" [value]="model?.order?.pickupPhone"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['pickupNotes']}}</td>
                    <td>
                      <dynamic-value [type]="'textarea'" [value]="model?.order?.pickupNotes"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['pickupContacts']}}</td>
                    <td>
                      <contacts-detail [model]="model.pickupContacts"></contacts-detail>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['pickupEmail']}}</td>
                    <td>
                      <div *ngFor="let p of model.pickupContacts">
                        <dynamic-value [type]="'text'" [value]="p.email"></dynamic-value>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>{{detailMetadata['pickupPhones']}}</td>
                    <td>
                      <div *ngFor="let p of pickupPhones">
                        <dynamic-value [type]="'phone'" [value]="p"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
         <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Dispatch Info</div>
            <div class="border-bottom"></div>
            <div class="cards-items">
              <table class="detail-table">
                <th id="invoice-details-dispatch-info" class="th-display-none"></th>
                <tbody>
                  <tr *ngIf="isNewBookedOrderNumber">
                    <td>{{detailMetadata['whoBooked']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.whoBookedName"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="isNewBookedOrderNumber">
                    <td>{{detailMetadata['bookedBy']}}</td>
                    <td>
                      <dynamic-value [type]="'lookup'" [value]="model?.order?.bookedBy" [items]="lookups.bookedBy"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>Carrier:</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.assignedCarrierName"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>Carrier Phone Numbers:</td>
                    <td>
                      <dynamic-value [type]="'phone'" [value]="model?.order?.carrierBusinessPhone"></dynamic-value>
                      <div *ngFor="let p of carrierPhones">
                        <dynamic-value [type]="'phone'" [value]="p"></dynamic-value>
                      </div>
                      <div *ngIf="model?.order?.carrierPhone != null">
                        <dynamic-value [type]="'phone'" [value]="model?.order?.carrierPhone"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Dispatcher:</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.dispatcherName"></dynamic-value>
                      {{(model?.order?.dispatcherPhone) ? ', ' : ''}} <dynamic-value [type]="'phone'"
                        [value]="model?.order?.dispatcherPhone"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>Dispatcher Email:</td>
                    <td>
                      <dynamic-value [type]="'email'" [value]="model?.order?.dispatcherEmail"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="!isNewRecordForTruckOverhual">
                    <td>Driver:</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.driverName"></dynamic-value>{{(model?.order?.driverPhone) ?
                      ',' : ''}} <dynamic-value [type]="'phone'" [value]="model?.order?.driverPhone"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="isNewRecordForTruckOverhual">
                    <td>Driver:</td>
                    <td *ngFor="let d of driverNames; let i = index" style="display:block;padding:0;">
                      <div>
                        <dynamic-value [type]="'text'" [value]="d"></dynamic-value>
                        <ng-container *ngIf="i < driverPhones.length">{{', '}}
                          <dynamic-value [type]="'text'" [value]="driverPhones[i]"></dynamic-value>
                        </ng-container>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{'Trailer Size:'}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.trailerSize"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{'Cargo/Liability Limits:'}}</td>
                    <td class="py-0">
                      <div class="cargo-limit-multiple-policy">
                        <ng-container *ngIf="model.carrierPolicyDetail && model.carrierPolicyDetail.length > 0; else noPolicy"
                          class="cargo-policy-container">
                          <div *ngFor="let policy of model.carrierPolicyDetail" class="cargo-policy-container">
                            <div *ngFor="let cargo of policy.cargoLimit">
                              {{ formatCurrency(cargo.cargoInsuranceLimit) }} ;
                              {{ cargo.cargoInsuranceDeductible ? formatCurrency(cargo.cargoInsuranceDeductible) : '--' }}
                            </div>
                            <div *ngFor="let liability of policy.liabilityLimit">
                              {{ formatCurrency(liability.liabilityLimit) }}
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <ng-template #noPolicy>--</ng-template>
                    </td>
                  </tr>
                  <tr>
                    <td>Price To Carrier:</td>
                    <td>
                      <dynamic-value [type]="'currency'" [value]="model?.order?.priceToCarrier"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>Payment Terms:</td>
                    <td *ngIf="!isPaymentTermsReadOnly">
                      <dynamic-value [type]="'lookup'" [value]="paymentTerms" [items]="lookups.paymentTerms">
                      </dynamic-value>
                    </td>
                    <td *ngIf="isPaymentTermsReadOnly">
                      N/A
                    </td>
                  </tr>
                  <tr>
                    <td>Price To Carrier (Adjusted):</td>
                    <td>
                      <dynamic-value [type]="'currency'" [value]="priceToCarrierAdjusted"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>Broker Fee Prepaid:</td>
                    <td>
                      <dynamic-value [type]="'lookup'" [value]="model?.order?.brokerFeePaid" [items]="lookups.yesNoNa">
                      </dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{model?.order?.brokerFeePaid == 2 ? 'Broker Fee Prepaid Amount:' : 'Broker Fee Amount:'}}</td>
                    <td>
                      <dynamic-value [type]="'currency'" [value]="model?.order?.brokerFee"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="model?.order?.brokerFeePaid == 2">
                    <td>Broker Fee Paid Date:</td>
                    <td>
                      {{brokerFeePaidDate}}
                    </td>
                  </tr>
                  <tr *ngIf="model?.order?.brokerFeePaid == 2">
                    <td>Broker Fee Payment Method:</td>
                    <td>
                      <dynamic-value [type]="'lookup'" [value]="model?.order?.brokerFeePaymentMethod"
                        [items]="lookups.paymentMethod"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="model?.order?.status > 1">
                    <td>Download documents:</td>
                    <td>
                      <a *ngIf="!isDownloadingCarrierTerms" style="float: left;" class="link-button"
                      (click)="downloadCarrierTerms()">Download Carrier Terms</a>
                    <a *ngIf="isDownloadingCarrierTerms" style="float: left; color: #444 !important;"
                      class="link-button">Download Carrier Terms</a>
                    <span style="float: left; padding-left: 5px;" *ngIf="isDownloadingCarrierTerms"><i
                        class="fa fa-spinner fa-spin"></i></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Order Info</div>
            <div class="border-bottom"></div>
            <div class="cards-items">
              <table class="detail-table table-four-col">
                <th id="invoice-details-order-info" class="th-display-none"></th>
                <tbody>
                  <tr>
                      <td>Rush:
                      <div class="table-data">
                        <dynamic-value [type]="'boolean'" [value]="model?.order?.rush"></dynamic-value>
                      </div>
                    </td>
                      <td class="order-detail-font">VIP:
                      <div class="table-data">
                        <dynamic-value [type]="'boolean'" [value]="model?.order?.vip"></dynamic-value>
                      </div>
                    </td>
                      <td class="order-detail-font">Pay Drop:
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model?.order?.payDrop" [items]="lookups.yesNoNull">
                        </dynamic-value>
                      </div>
                    </td>
                      <td class="order-detail-font">Per Vehicle Pay Drop Amount:
                      <div class="table-data">
                        <dynamic-value [type]="'currency'" [value]="model?.order?.perVehicleDollarAmount"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                      <td colspan="4">Pay Drop Reason:
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model?.order?.payDropReason">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                      <td colspan="4">Review Required?:
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model?.order?.reviewRequired" [items]="lookups.reviewRequested">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr [style.background]="model?.order?.depositRequired !=null &&  model?.order?.depositRequired==2 ? 'rgba(250, 250, 0, 0.7)' : null">
                    <td colspan="4"> Deposit Required?:
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model?.order?.depositRequired"
                          [items]="lookups.yesNoNa">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                      <td colspan="4">Documentation Necessary for Pickup/Delivery:
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model?.order?.isDocumentationNecessary"
                          [items]="lookups.yesNoNa">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">Documents:
                      <uploads [isOrderDoc]="true" [orderId]="model?.order?.id" [orderGuid]="model?.order?.guid" [showAdd]="false" [showDelete]="false"></uploads>
                    </td>
                  </tr>
                  <tr>
                      <td colspan="4"><span>Special Instructions: </span>
                      <span class="table-data" style="white-space: pre-wrap; font-weight: normal;">
                        <ng-container *ngIf="parsedSpecialInstructions.length > 0">
                          <span *ngFor="let part of parsedSpecialInstructions" 
                                [ngClass]="{'pickup-password': part.isPickupPassword}">{{part.text}}</span>
                        </ng-container>
                        <span *ngIf="parsedSpecialInstructions.length === 0">{{model?.order?.specialInstructions}}</span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Delivery Info</div>
            <div class="border-bottom"></div>
            <div class="delivery-cards-items">
              <table class="detail-table">
                <th id="order-detail-delivery-info" class="th-display-none"></th>
                <tbody>
                  @if (isNewRecordForDateOverhual) {
                    <div class="date-overhaul-record">
                      @for (customerExpectedDeliveryDate of customerExpectedDeliveryDates; track customerExpectedDeliveryDate; let i = $index) {
                        <tr>
                          <td>{{detailMetadata['customerExpectedDeliveryDates']}} {{i+1}}</td>
                          <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: customerExpectedDeliveryDate }"></ng-template>
                        </tr>
                      }
                    </div>
                  }
                  <tr>
                    <td>{{detailMetadata['customerExpectedDelivery']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.customerExpectedDelivery"></dynamic-value>
                    </td>
                  </tr>
                  @if (isNewRecordForDateOverhual) {
                    <div class="date-overhaul-record">
                      @for (carrierScheduledDeliveryDate of carrierScheduledDeliveryDates; track carrierScheduledDeliveryDate; let i = $index) {
                        <tr>
                          <td>{{detailMetadata['carrierScheduledDeliveryDates']}} {{i+1}}</td>
                          <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: carrierScheduledDeliveryDate }"></ng-template>
                        </tr>
                      }
                    </div>
                  }
                  <tr>
                    <td>{{isNewRecordForDateOverhual ?  detailMetadata['carrierDeliveryDateNote'] : detailMetadata['scheduledDelivery']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.scheduledDelivery"></dynamic-value>
                    </td>
                  </tr>
                  @if (isNewRecordForDateOverhual) {
                    <div class="date-overhaul-record">
                      @for (deliveryNewETADate of deliveryNewETADates; track deliveryNewETADate; let i = $index) {
                        <tr>
                          <td>{{detailMetadata['deliveryNewETADates']}} {{i+1}}</td>
                          <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: deliveryNewETADate }"></ng-template>
                        </tr>
                      }
                    </div>
                  }
                  <tr>
                    <td>{{detailMetadata['actualDeliveryDate']}}
                      <div class="table-data">
                        <dynamic-value [type]="'date'" [value]="model?.order?.actualDeliveryDate"></dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">{{detailMetadata['deliveryConfirmedBy']}}
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model?.order?.deliveryConfirmedBy"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="order-detail-font">{{detailMetadata['deliveryUpdatedUser']}}

                      <div class="table-data">

                        <dynamic-value [type]="'text'" [value]="model?.order?.deliveryUpdatedUser"></dynamic-value>

                      </div>

                    </td>
                    <td class="order-detail-font">{{detailMetadata['deliveryUpdatedTimedate']}}

                      <div class="table-data">

                        <dynamic-value [type]="'datetime'" [value]="model?.order?.deliveryUpdatedTimedate"></dynamic-value>

                      </div>

                    </td>

                  </tr>
                  <tr *ngIf="model?.order?.callback2">
                    <td>{{detailMetadata['callback2date']}}:
                      <div class="table-data">
                       <span class="font-weight-normal"> {{ model?.order?.callback2date |  date: 'MM/dd/yyyy' }} </span>
                      </div>
                    </td>
                    <td class="order-detail-font">{{detailMetadata['callback2time_only']}}:
                      <div class="table-data">
                        <span class="font-weight-normal"> {{model?.order?.callback2date | date:'mediumTime'}}</span>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="model?.order?.callback2">
                    <td>{{detailMetadata['callback2note']}}</td>
                    <td>
                      <dynamic-value [type]="'textarea'" [class]="'callback-readonly-height callback-inputbox'" [value]="model?.order?.callback2note"></dynamic-value>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="border-bottom-delivery"></div>
            <div class="cards-items">
              <table class="detail-table">
              <tbody>
                  <tr>
                    <td>{{detailMetadata['deliveryBusinessName']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.deliveryBusinessName"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['deliveryBusinessHours']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.deliveryBusinessHours"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['deliveryAddress1']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.order?.deliveryAddress1" display="block"></dynamic-value>
                      <dynamic-value [type]="'text'" [value]="model?.order?.deliveryCity"></dynamic-value>{{(model?.deliveryCity
                      &&
                      (model?.deliveryStateCode || model?.deliveryZip)) ? ', ' : ''}}<dynamic-value [type]="'text'"
                        [value]="model?.order?.deliveryStateCode"></dynamic-value>&nbsp;<dynamic-value [type]="'zip'"
                        [value]="model?.order?.deliveryZip"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['deliveryPhone']}}</td>
                    <td>
                      <dynamic-value [type]="'phone'" [value]="model?.order?.deliveryPhone"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['deliveryNotes']}}</td>
                    <td>
                      <dynamic-value [type]="'textarea'" [value]="model?.order?.deliveryNotes"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['deliveryContacts']}}</td>
                    <td>
                      <contacts-detail [model]="model.deliveryContacts"></contacts-detail>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['deliveryEmail']}}</td>
                    <td>
                      <div *ngFor="let d of model.deliveryContacts">
                        <dynamic-value [type]="'text'" [value]="d.email"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{detailMetadata['deliveryPhones']}}</td>
                    <td>
                      <div *ngFor="let p of deliveryPhones">
                        <dynamic-value [type]="'phone'" [value]="p"></dynamic-value>
                      </div>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards vehicles-detail" *ngIf="showVehicles">
            <vehicles-detail [model]="model.vehicles" [openEnclosed]="model.openEnclosed"></vehicles-detail>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Order Notes</div>
            <div class="border-bottom"></div>
            <div class="cards-items order-notes-scrollbar">
              <table class="detail-table">
                <th id="invoice-details-order-notes" class="th-display-none"></th>
                <tbody>
                  <tr>
                    <td colspan="2">
                      <notes-detail [entityName]="'order'" [entityId]="model?.order?.id" [showAdd]="false" [notesOnly]="true">
                      </notes-detail>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">New ETA Notes</div>
            <div class="border-bottom"></div>
            <div class="cards-items order-notes-scrollbar">
              <notes-detail [entityName]="'order'" [entityId]="model?.order?.id" [showAdd]="false" [notesOnly]="true"  [isNewETANotes]="true">
              </notes-detail>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="showCancelWarning" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false"
  [closable]="false" appendTo="body">
  <div class="modal-body-custom">
    <div class="regular-text muted6 bold">
      Are you sure you want to exit without saving? Any unsaved data will be lost.
    </div>
  </div>
  <div class="ui-dialog ui-dialog-footer">
    <div class="modal-footer-custom">
      <div class="link-button d-inline-block">
        <a class="muted7" (click)="showCancelWarning = false;">No</a>
      </div>
      <div class="link-button float-right d-inline-block">
        <button class="link-button" type="button" (click)="confirmClose()">Yes</button>
      </div>
    </div>
  </div>
</p-dialog>
<ng-template #dateoverhaul let-data>
  <td class="date-overhaul-spacing">
    <ng-container *ngIf="data.startDate; else dash">
      <dynamic-value [type]="'date'" [value]="data.startDate"></dynamic-value>
    </ng-container>
    <ng-template #dash>
     <span class="td-dynamic-data">
       —
     </span>
    </ng-template>
    <span *ngIf="data.dateType == 2"> -
      <ng-container *ngIf="data.endDate; else dash">
        <dynamic-value [type]="'date'" [value]="data.endDate"></dynamic-value>
      </ng-container>
      <ng-template #dash>
       <span class="td-dynamic-data">
         —
       </span>
      </ng-template>
    </span>
  </td>
</ng-template>
